<template>
  <div class="configure">
    <div class="center">
      <div v-if="tabstuts == 'AvantLink'">
        <pre class="font24 font_bo">AvantLink API授权指引文档</pre>

        <pre>只需几分钟，将 AvantLink 连接到 FOSHO AFF，用一个工具高效管理您的多个联盟营销平台账户。


       </pre>
        <pre class="font24 font_bo">AvantLink API 集成 </pre>

        <pre>● 商家会员ID（Merchant ID）</pre>
        <pre>● API 授权码（API Key）


       </pre>
        <pre class="font24 font_bo">如何找到“商家会员ID”？


       </pre>
        <pre>● 登录您的 AvantLink 商家账户</pre>
        <pre>● 您的会员 ID 显示在右上角——您的帐户名称下方</pre>
        <img src="@/assets/img/sqzx/01.jpeg" alt="">
        <pre class="font24 font_bo">


如何获取 AvantLink API 授权码？
       </pre>
        <pre>● 登录您的 AvantLink 商家账户</pre>
        <pre>● 点击右侧的❓问号按钮，进入 Support 窗口</pre>
        <pre>● 输入 API 搜索后，点击右下角的”联系我们“按钮，通过账号的绑定邮箱，在窗口中留言，参考内容如下：

       </pre>
        <pre class="font20 font_bo">    标题（可选）</pre>
        <pre>     API integration</pre>
        <pre class="font20 font_bo">    有什么我们可以帮忙的？</pre>
        <pre>     Dear Support team,

       </pre>
        <pre>    We'd like to retrieve AvantLink reports via API, could you please provide our API Key? Thanks!</pre>
        <img src="@/assets/img/sqzx/02.jpeg" alt="">
        <pre>


● 提交后请注意查收邮件，客服人员可能会与您二次确认
       </pre>
        <pre>● 请求确认后，您的 API 授权码会通过 AvantLink 平台右上角的 🔔 提示向您提供，点击展开即可获取</pre>
        <img src="@/assets/img/sqzx/03.jpeg" alt="">
        <pre>


<pre>如需技术协助或有其他问题，请联系 support@foshobrands.com 或您的客户经理。</pre>
        </pre>
      </div>
      <div v-if="tabstuts == 'ShareASale'">
        <pre class="font24 font_bo">ShareASale API授权指引文档</pre>
        <pre>只需几分钟，将 ShareASale 连接到 FOSHO AFF，用一个工具高效管理您的多个联盟营销平台账户。


        </pre>
        <pre class="font24 font_bo">ShareASale API 集成</pre>
        <pre>我们需要获取您的：</pre>
        <pre>● 商家会员ID（Merchant ID）</pre>
        <pre>● API 凭证（Token）</pre>
        <pre>● API 密钥（Secret Key）


        </pre>
        <pre class="font24 font_bo">如何找到“商家会员ID”？</pre>
        <pre>● 登录您的 ShareASale 商家账户</pre>
        <pre>● 您的会员 ID# 显示在左上角——您的帐户名称下方</pre>
        <img src="@/assets/img/sqzx/01.png" alt="">
        <pre class="font24 font_bo">如何找到 ShareASale API 凭证和密钥？


        </pre>
        <pre>● 登录您的 ShareASale 商家账户</pre>
        <pre>● 从顶部导航栏前往 Tools – Merchant API （或前往该链接：<a href="https://account.shareasale.com/m-apiips.cfm">https://account.shareasale.com/m-apiips.cfm</a> ）</pre>
        <pre>● 向下滑动页面找到 Token 和 API Secret</pre>
        <pre>请确保将 IP 配置选项选中为“Require IP address match only for version 1.1 and lower”，并点击 Update Settings 保存</pre>
        <img src="@/assets/img/sqzx/04.jpeg" alt="">
        <pre>API 请求限制为每月 200 个，由于这个限制，我们每天只能更新一次数据。

        </pre>
        <pre>如需技术协助或有其他问题，请联系 support@foshobrands.com 或您的客户经理。</pre>
      </div>
      <div v-if="tabstuts == 'Awin'">
        <pre>只需几分钟，将 Awin 连接到 FOSHO AFF，用一个工具高效管理您的多个联盟营销平台账户。
        </pre>

        <pre class="font24 font_bo">Awin API 集成</pre>

        <pre>我们需要获取您的：</pre>
        <pre>● 商家会员ID（Publisher ID）</pre>
        <pre>● API 授权码（API Key）

        </pre>
        <pre>如何找到商家会员ID？
        </pre>

        <pre>● 登录您的 Awin商家账户</pre>
        <pre>● 登录后您的页面会跳转到看板页面，子账户会显示在此页面 （链接：https://ui.awin.com/user）</pre>
        <pre>● 输入您的帐户密码, 点击生成我的 API凭证 “Generate my API token”. 如果输入密码后密钥显示出来，点击显示API 密钥按钮“Show my API tokens” .</pre>
        <img src="@/assets/img/sqzx/Awin1.jpeg" alt="">
        <pre>


        </pre>
        <pre class="font24 font_bo">如何找到 AWIN API 授权码？
        </pre>

        <pre>● 登录您的 Awin 商家账户</pre>
        <pre>● 您的会员名称显示在右上角, 点击展开选择 API Credentials.</pre>
        <pre>● 输入您的帐户密码, 点击生成我的 API凭证 “Generate my API token”. 如果输入密码后密钥显示出来，点击显示API 密钥按钮“Show my API tokens” .</pre>
        <img src="@/assets/img/sqzx/Awin2.jpeg" alt="">

      </div>
      <div v-if="tabstuts == 'Partnerize'">
        <pre>只需几分钟，将Partneriz 连接到 FOSHO AFF，用一个工具高效管理您的多个联盟营销平台账户。
        </pre>

        <pre class="font24 font_bo">Partneriz API 集成</pre>

        <pre>我们需要获取您的：</pre>

        <pre>● 商家会员ID（Publisher ID）</pre>
        <pre>● API 授权码（API Key）</pre>
        <pre>● 应用程序密钥 （Application Key）

        </pre>
        <pre class="font24 font_bo">如何找到商家会员ID？

        </pre>

        <pre>● 登录您的 Partnerize 账户</pre>
        <pre>● 点击跳转到合作伙伴设置 （Partner Settings） 页面</pre>
        <pre>● 看到会员ID 显示在左侧栏，或者您可以之间点击链接</pre>
            <pre>● （ <a href="https://console.partnerize.com/v2/settings/publisher">https://console.partnerize.com/v2/settings/publisher</a> ）</pre>
        <img src="@/assets/img/sqzx/Partnerize1.jpeg" alt="">
        <pre>

        </pre>
        <pre class="font24 font_bo">如何获取 Partneriz API 授权码？
        </pre>
        <pre>● 登录您的 Partneriz 商家账户</pre>
        <pre>● 点击去账号设置 （Account Setting）</pre>
        <pre>● 点击显示密码按钮（眼睛标志）查看 API 授权码</pre>
        <pre>● 您也可以直接点击链接跳转到该页面 <a href="https://console.partnerize.com/v2/settings/user">https://console.partnerize.com/v2/settings/user</a> </pre>
        <img src="@/assets/img/sqzx/P.png" alt="">
        <pre>

        </pre>
        <pre>如何查看应用程序密钥？

        </pre>
        <pre>● 登录您的 Partneriz 商家账户</pre>
        <pre>● 点击去账号设置 （Account Setting）</pre>
        <pre>● 点击显示密码按钮（眼睛标志）查看应用程序密钥</pre>
        <pre>● 您也可以直接点击链接跳转到该页面 <a href="https://console.partnerize.com/v2/settings/user">https://console.partnerize.com/v2/settings/user</a> </pre>
        <img src="@/assets/img/sqzx/P2.png" alt="">
      </div>
      <div v-if="tabstuts == 'Rakuten'">
        <pre>只需几分钟，将Rakuten连接到 FOSHO AFF，用一个工具高效管理您的多个联盟营销平台账户。</pre>
        <pre class="font24 font_bo">Rakuten API 集成


        </pre>
        <pre>
          我们需要获取您的：
        </pre>
        <pre>● 平台ID（Network ID）</pre>
        <pre>● API 授权码（API Token）


        </pre>
        <pre class="font24 font_bo">如何找到 Raketen API 授权码？

        </pre>
        <pre>● 登录您的 Raketen 商家账户</pre>
        <pre>● 点击报告(Reports) > 报告(Reporting)</pre>
        <pre>● 选择一个可查看报告 （比如：销售总额和佣金报告 Gross Sales and Commissions Report）</pre>
        <pre>● 点击左侧查看报告“View Report”按钮, 选择获取API"Get API"</pre>
        <pre>● 弹窗中 “ & token=" 后面的内容就是您的API 授权码， 截止到“%3D%3D”之前。</pre>
        <img src="@/assets/img/sqzx/R.png" alt="">
      </div>
      <div v-if="tabstuts == 'TradeDoubler'">
        <pre>只需几分钟，将Tradedoubler 连接到 FOSHO AFF，用一个工具高效管理您的多个联盟营销平台账户。
          

        </pre>
        <pre class="font24 font_bo">Tradedoubler API 集成
          
        </pre>
        <pre>我们需要获取您的：

        </pre>
        <pre>● 客户端授权码（Client Secret）</pre>
        <pre>● 客户端ID（Client ID）</pre>
        <pre>● 位置 ID （Site ID's）


        </pre>
        <pre class="font24 font_bo">如何找到客户端授权码？

        </pre>
        <pre>● 登录您的 Tradedoubler 账户</pre>
        <pre>● 您可以找到客户端授权码在 账户>客户 （Account>Clients）</pre>
        <pre>   https://publishers.tradedoubler.com/account/clients）</pre>
        <pre>● 注意事项：只有当您添加客户在账户里时，客户端授权码才会显示这唯一一次

        </pre>
        <img src="@/assets/img/sqzx/ACC.png" alt="">
        <pre>

        </pre>
        <pre class="font24 font_bo">如何获取客户端ID？

        </pre>
        <pre>● 登录您的 Tradedoubler 账户</pre>
        <pre>● 您可以找到客户端ID在 账户>客户 （Account>Clients）</pre>
        <pre>  <a href="https://publishers.tradedoubler.com/account/clients">https://publishers.tradedoubler.com/account/clients</a>
        </pre>
        <img src="@/assets/img/sqzx/ACC2.png" alt="">
        <pre>

        </pre>
        <pre class="font24 font_bo">如何找到位置 ID ？

        </pre>
        <pre>● 登录您的 Tradedoubler 账户</pre>
        <pre>● 您可以找到位置（Site）找到 位置 ID，或者点击链接</pre>
        <pre>  <a href="https://publishers.tradedoubler.com/sites">https://publishers.tradedoubler.com/sites</a></pre>
        <pre>● 位置 ID显示在网站名称的后面

        </pre>
        <img src="@/assets/img/sqzx/ACC3.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabstuts: this.$route.query.type
    }
  }
}
</script>
<style lang="less" scoped>
.configure {
  width: 100%;
  background: #fff;
  .center {
    text-align: left;
    padding: 40px 0 80px 0;
    width: 1200px;
    margin: 0 auto;
    .font24 {
      font-size: 24px;
    }
    .font20 {
      font-size: 20px;
    }
    img {
      width: 100%;
    }
  }
}
pre{
  font-size: 16px;
}
a{
  color: rgba(54,142,248);
}
</style>